import { useMemo } from "react";
import Chart from "react-apexcharts";

const UserGrowthChart = ({ userStats = [], themeColor, textColor }) => {
  const rootStyle = getComputedStyle(document.documentElement);
  const themeColorSecondary = `rgb(${rootStyle
    .getPropertyValue("--theme-color-secondary")
    .trim()})`;

  const hasData = userStats.length > 0;

  const fallbackMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun"];

  const xCategories = hasData
    ? userStats.map(u => u.month)
    : fallbackMonths;

  const seriesData = hasData
    ? userStats.map(u => u.users)
    : new Array(fallbackMonths.length).fill(0);

  // ✅ Current month summary
  const currentMonthValue = hasData
    ? userStats[userStats.length - 1]?.users || 0
    : 0;

  const currentMonthLabel = hasData
    ? userStats[userStats.length - 1]?.month
    : "Current Month";

  const userGrowthOptions = useMemo(() => ({
    chart: {
      type: "area",
      toolbar: { show: false },
      fontFamily: "var(--theme-font)",
      width: "100%",
    },
    dataLabels: { enabled: false },
    stroke: {
      curve: "smooth",
      width: hasData ? 3 : 0,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 0.8,
        opacityFrom: hasData ? 0.5 : 0,
        opacityTo: 0,
        stops: [0, 100],
        colorStops: [
          { offset: 0, color: themeColorSecondary, opacity: hasData ? 0.5 : 0 },
          { offset: 100, color: themeColorSecondary, opacity: 0 },
        ],
      },
    },
    xaxis: {
      categories: xCategories,
      labels: {
        style: { colors: textColor, fontSize: "12px" },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      min: 0,
      max: hasData ? undefined : 100,
      tickAmount: 5,
      labels: {
        style: { colors: textColor, fontSize: "12px" },
      },
    },
    colors: [themeColor],
    tooltip: { enabled: hasData },
    grid: {
      borderColor: "rgba(0,0,0,0.06)",
      strokeDashArray: 4,
    },
    states: {
      hover: { filter: { type: "none" } },
      active: { filter: { type: "none" } },
    },
  }), [hasData, xCategories, themeColor, themeColorSecondary, textColor]);

  const userGrowthSeries = [
    { name: "Users", data: seriesData }
  ];

  return (
    <div className="user-growth-wrapper">
      {/* 🔝 Header Summary */}
      <div className="chart-summary">
        <div className="chart-summary-inner">
          <span className="summary-label">
            Users · {currentMonthLabel}
          </span>
          <h3 className="summary-value">
            {currentMonthValue.toLocaleString()}
          </h3>
        </div>
      </div>

      <Chart
        options={userGrowthOptions}
        series={userGrowthSeries}
        type="area"
        height={500}
        width="100%"
      />
    </div>
  );
};

export default UserGrowthChart;
